/* ============================================================
   RelationCell — relation 컬럼 값을 클릭 가능한 칩으로 렌더
   값 형태(둘 다 허용):
     1) 배열: [{ id:'<rowPageId>', title:'<제목>' }, ...]  ← 신규 importer 포맷
        - id 만 있는 형태([{ id }, ...]) 또는 문자열 id 배열(['id', ...])도 허용
     2) 레거시 문자열: "3개 연결" / 임의 평문 → 평문 그대로 표시 (깨지지 않게)
     3) 빈 값(null/''/[]): 빈 셀
   각 칩은 react-router Link 로 /page/<id> 이동.
   ============================================================ */
import { Link } from 'react-router-dom';

/* 칩이 셀 안에서 줄바꿈되도록 (.cell 은 nowrap flex) */
const WRAP = { flexWrap: 'wrap', gap: '4px', rowGap: '4px' };
/* Link 는 a 태그라 밑줄/색 상속을 끊어 기존 .tag(span) 와 동일한 칩 모양 유지 */
const CHIP_LINK = { textDecoration: 'none', cursor: 'pointer', maxWidth: '100%' };
const CHIP_OVERFLOW = { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' };

/* 배열 항목 1개를 { id, title } 로 정규화
   titleById(선택): rowPageId → { title, icon } 맵 — 문자열 id 배열의 제목 해석용 */
function normItem(item, titleById) {
  if (item == null) return null;
  if (typeof item === 'string') {
    const t = titleById?.get?.(item);
    return { id: item, title: t ? (t.title || '제목 없음') : item };
  }
  if (typeof item === 'object') {
    const id = item.id ?? item.page_id ?? null;
    const title = item.title ?? item.name ?? titleById?.get?.(id)?.title ?? id ?? '';
    return { id, title };
  }
  return null;
}

export default function RelationCell({ value, titleById }) {
  // 배열 형태 → 칩 렌더
  if (Array.isArray(value)) {
    const items = value.map((it) => normItem(it, titleById)).filter((it) => it && (it.id || it.title));
    if (items.length === 0) {
      return <div className="cell rel-cell" />;
    }
    return (
      <div className="cell rel-cell" style={WRAP}>
        {items.map((it, i) => {
          const label = it.title || it.id;
          // id 가 없으면 링크 불가 → 칩만 표시
          if (!it.id) {
            return (
              <span className="tag tg rel-chip" key={i} title={label} style={CHIP_OVERFLOW}>
                {label}
              </span>
            );
          }
          return (
            <Link
              className="tag tg rel-chip"
              key={it.id || i}
              to={`/page/${it.id}`}
              title={label}
              style={{ ...CHIP_LINK, ...CHIP_OVERFLOW }}
            >
              {label}
            </Link>
          );
        })}
      </div>
    );
  }

  // 레거시 문자열 / 기타 평문 → 그대로 표시 (현재 동작 보존)
  if (value === '' || value == null) {
    return <div className="cell rel-cell" />;
  }
  return <div className="cell rel-cell">{String(value)}</div>;
}
